<template>
  <div class="me-page">
    <!-- 用户信息卡片 -->
    <div class="user-card">
      <div class="user-avatar-container">
        <img src="../assets/1.png" alt="用户头像" class="user-avatar" />
        <div v-if="isAdmin" class="admin-badge">管理员</div>
      </div>
      <div class="user-info">
        <h2 class="username">{{ userInfo ? userInfo.username : '未登录' }}</h2>
        <p class="user-id">ID: {{ userInfo ? userInfo.id : '--' }}</p>
        <div class="points-badge">
          <img src="../assets/icon/jifen.svg" alt="积分" class="points-icon" />
          <span class="points-value">{{ userInfo ? userInfo.points : '0' }}</span>
          <span class="points-label">积分</span>
        </div>
      </div>
    </div>

    <!-- 功能菜单 -->
    <div class="menu-section">
      <!-- 管理员专属菜单 -->
      <div v-if="isAdmin" class="menu-item admin-menu-item" @click="showGenerateCardModal">
        <div class="menu-icon admin-icon">
          <img src="../assets/icon/jifen.svg" alt="生成卡密" class="menu-icon-img" />
        </div>
        <div class="menu-text">生成卡密</div>
        <div class="menu-arrow">›</div>
      </div>
      
      <div class="menu-item" @click="contactAdmin">
        <div class="menu-icon contact-icon">
          <img src="../assets/icon/guanli.svg" alt="联系管理员" class="menu-icon-img" />
        </div>
        <div class="menu-text">联系管理员</div>
        <div class="menu-arrow">›</div>
      </div>
      
      <div class="menu-item logout" @click="logout">
        <div class="menu-icon logout-icon">
          <img src="../assets/icon/layout.svg" alt="退出登录" class="menu-icon-img" />
        </div>
        <div class="menu-text">退出登录</div>
        <div class="menu-arrow">›</div>
      </div>
    </div>

    <!-- 版本信息 -->
    <div class="version-info">
      <p>版本 v1.0.0</p>
    </div>
    
    <!-- 生成卡密模态框 -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>生成卡密</h3>
          <button class="close-btn" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <label for="points">积分值</label>
            <input 
              type="number" 
              id="points"
              v-model="cardForm.points" 
              placeholder="请输入卡密积分值"
              class="card-input"
              min="1"
            />
          </div>
          <div class="input-group">
            <label for="count">生成数量</label>
            <input 
              type="number" 
              id="count"
              v-model="cardForm.count" 
              placeholder="请输入生成数量"
              class="card-input"
              min="1"
              max="100"
            />
          </div>
          <button 
            class="submit-btn" 
            @click="generateCards"
            :disabled="isGenerating"
          >
            {{ isGenerating ? '生成中...' : '生成卡密' }}
          </button>
          
          <!-- 生成结果 -->
          <div v-if="generatedCards.length > 0" class="generated-cards">
            <h4>生成的卡密：</h4>
            <div class="cards-container">
              <div v-for="(card, index) in generatedCards" :key="index" class="card-item">
                <div class="card-key">{{ card.card_key }}</div>
                <div class="card-points">{{ card.points }}积分</div>
              </div>
            </div>
            <button class="copy-btn" @click="copyGeneratedCards">
              复制全部
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '../utils/axios';
import { useRouter } from 'vue-router';

export default {
  name: 'MeView',
  setup() {
    const router = useRouter();
    return { router };
  },
  data() {
    return {
      userInfo: null,
      loading: false,
      error: null,
      showModal: false,
      isGenerating: false,
      cardForm: {
        points: 100,
        count: 1
      },
      generatedCards: []
    }
  },
  computed: {
    isAdmin() {
      return this.userInfo && this.userInfo.role === '2';
    }
  },
  mounted() {
    this.fetchUserInfo();
  },
  methods: {
    async fetchUserInfo() {
      // 检查是否登录
      if (!localStorage.getItem('token')) {
        this.router.push('/login');
        return;
      }
      
      this.loading = true;
      this.error = null;
      
      try {
        // 始终从服务器获取最新数据
        const response = await api.getUserInfo();
        
        if (response.success) {
          console.log('获取到用户信息:', response.data);
          this.userInfo = response.data;
          // 更新缓存的用户信息
          localStorage.setItem('user', JSON.stringify(response.data));
        } else {
          this.error = response.message;
          console.error('获取用户信息失败:', response.message);
          if (response.message.includes('认证') || response.message.includes('token')) {
            // 认证问题，返回登录页
            this.logout();
          }
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.error = '网络错误，请稍后重试';
        
        // 如果是401错误，跳转到登录页
        if (error.response && error.response.status === 401) {
          this.logout();
        }
      } finally {
        this.loading = false;
      }
    },
    
    contactAdmin() {
      // 可以替换为实际的联系方式
      alert('管理员微信: admin123\n或发送邮件至: admin@example.com');
    },
    
    logout() {
      // 清除token和用户信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // 跳转到登录页
      this.router.push('/login');
    },
    
    // 生成卡密相关方法
    showGenerateCardModal() {
      this.showModal = true;
      this.generatedCards = [];
    },
    
    closeModal() {
      this.showModal = false;
    },
    
    generateCards() {
      if (!this.cardForm.points || this.cardForm.points < 1) {
        alert('请输入有效的积分值');
        return;
      }
      
      if (!this.cardForm.count || this.cardForm.count < 1 || this.cardForm.count > 100) {
        alert('生成数量应在1-100之间');
        return;
      }
      
      this.isGenerating = true;
      
      // 调用API生成卡密
      api.generateCardKey({
        points: this.cardForm.points,
        count: this.cardForm.count
      })
        .then(response => {
          if (response.success) {
            this.generatedCards = response.data;
          } else {
            alert('生成卡密失败: ' + response.message);
          }
        })
        .catch(err => {
          console.error('生成卡密错误:', err);
          alert('网络错误，请稍后重试');
        })
        .finally(() => {
          this.isGenerating = false;
        });
    },
    
    generateRandomCardKey() {
      // 此方法仍保留，但实际生成卡密已改为调用API
      const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      let result = '';
      
      // 第一部分：8个随机字符
      for (let i = 0; i < 8; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      
      result += '-';
      
      // 中间部分：时间戳
      const timestamp = Date.now().toString(36).toUpperCase();
      result += timestamp.padStart(6, '0');
      
      result += '-';
      
      // 最后部分：8个随机字符
      for (let i = 0; i < 8; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      
      return result;
    },
    
    copyGeneratedCards() {
      const text = this.generatedCards.map(card => 
        `卡密: ${card.card_key}, 积分: ${card.points}`
      ).join('\n');
      
      navigator.clipboard.writeText(text)
        .then(() => {
          alert('已复制到剪贴板');
        })
        .catch(err => {
          console.error('复制失败:', err);
          alert('复制失败，请手动复制');
        });
    }
  }
}
</script>

<style scoped>
.me-page {
  padding: 20px;
  padding-bottom: 70px; /* 为底部导航栏留出空间 */
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 用户卡片样式 */
.user-card {
  width: 90%;
  max-width: 450px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.07);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.user-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, #1296db, #64b5f6);
  border-radius: 3px 3px 0 0;
}

.user-avatar-container {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 20px;
  flex-shrink: 0;
}

.user-avatar {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.admin-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #ff5722;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  transform: translateX(0);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.user-info {
  flex: 1;
}

.username {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 5px 0;
}

.user-id {
  font-size: 14px;
  color: #777;
  margin: 0 0 10px 0;
}

.points-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(18, 150, 219, 0.1);
  border-radius: 20px;
  padding: 6px 12px;
}

.points-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}

.points-value {
  font-weight: 700;
  color: #1296db;
  margin-right: 3px;
}

.points-label {
  font-size: 14px;
  color: #666;
}

/* 菜单样式 */
.menu-section {
  width: 90%;
  max-width: 450px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.07);
  margin-bottom: 20px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: background-color 0.2s;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

.menu-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-right: 15px;
}

.menu-icon-img {
  width: 22px;
  height: 22px;
}

.admin-icon {
  background-color: rgba(255, 152, 0, 0.1);
}

.contact-icon {
  background-color: rgba(76, 175, 80, 0.1);
}

.logout-icon {
  background-color: rgba(244, 67, 54, 0.1);
}

.menu-text {
  flex: 1;
  font-size: 16px;
  color: #444;
}

.menu-arrow {
  color: #ccc;
  font-size: 20px;
  font-weight: 300;
}

.menu-item.logout .menu-text {
  color: #F44336;
}

.admin-menu-item .menu-text {
  color: #FF9800;
  font-weight: 500;
}

/* 版本信息 */
.version-info {
  margin-top: auto;
  padding: 20px 0;
  color: #999;
  font-size: 12px;
  text-align: center;
}

/* 加载状态 */
.loading-indicator {
  margin: 40px 0;
  text-align: center;
  color: #1296db;
}

.error-message {
  width: 90%;
  max-width: 450px;
  padding: 15px;
  background-color: rgba(244, 67, 54, 0.1);
  color: #F44336;
  border-radius: 8px;
  margin-bottom: 20px;
  text-align: center;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.modal-content {
  width: 90%;
  max-width: 400px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  animation: modalShow 0.3s ease;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

@keyframes modalShow {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.modal-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: #333;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #666;
  padding: 0;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #333;
}

.modal-body {
  padding: 1.2rem;
  overflow-y: auto;
}

.input-group {
  margin-bottom: 1rem;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-size: 0.9rem;
}

.card-input {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.card-input:focus {
  outline: none;
  border-color: #1296db;
  box-shadow: 0 0 0 2px rgba(18, 150, 219, 0.1);
}

.submit-btn {
  width: 100%;
  padding: 0.8rem;
  background: linear-gradient(135deg, #FF9800, #FFC107);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.3s ease;
  cursor: pointer;
  margin-bottom: 1rem;
}

.submit-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #F57C00, #FFB300);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 152, 0, 0.2);
}

.submit-btn:active:not(:disabled) {
  transform: translateY(1px);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 生成的卡密样式 */
.generated-cards {
  margin-top: 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding-top: 1rem;
}

.generated-cards h4 {
  margin-top: 0;
  margin-bottom: 0.8rem;
  color: #555;
}

.cards-container {
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 1rem;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 0.5rem;
}

.card-item {
  padding: 0.8rem;
  background: white;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
}

.card-item:last-child {
  margin-bottom: 0;
}

.card-key {
  font-family: monospace;
  color: #333;
  font-size: 0.85rem;
}

.card-points {
  color: #FF9800;
  font-weight: 600;
  font-size: 0.85rem;
}

.copy-btn {
  padding: 0.6rem;
  background: #f0f0f0;
  color: #555;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  width: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.copy-btn:hover {
  background: #e0e0e0;
}
</style> 